module.exports = __webpack_public_path__ + "img/技术优势1.ca7829f0.png";